import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

export class RangeSlider {
    constructor(element) {
        this.element = element;
        if (!this.element) return;

        this.step = +this.element.dataset.step || 1;
        this.margin = +this.element.dataset.margin || 0;
        this.suffix = this.element.dataset.suffix || '';

        this.inputMin = this.element.querySelector('.price-min');
        this.inputMax = this.element.querySelector('.price-max');
        if (!this.inputMin || !this.inputMax) return;

        this.min = +this.inputMin.dataset.range || 0;
        this.max = +this.inputMax.dataset.range || 10000;
        this.inputs = [this.inputMin, this.inputMax];

        this.slider = null;
        this.SLIDER_SELECTOR = '.filter-slider__range';

        this.FIRST_UPDATE_COUNT = 2;
        this.isRangeInit = false;

        this.resultElement = this.element.querySelector('.filter-dropdown__text');

        this.placeholderFormat = wNumb({
            decimals: 0,
            thousand: ' ',
        });

        this.init();
    }

    init() {
        const stepsSlider = this.element.querySelector(this.SLIDER_SELECTOR);
        if (!stepsSlider) return;

        const range = {
            min: this.min,
            max: this.max,
        };

        const start = this.checkInitValue();

        this.slider = noUiSlider.create(stepsSlider, {
            start,
            range,
            margin: this.margin,
            step: this.step,
            connect: true,
            format: wNumb({
                decimals: 0,
                thousand: ' ',
            }),
        });

        this.initHandlers();
    }

    initHandlers() {
        this.slider.on('update', (values, handle) => {
            if (this.FIRST_UPDATE_COUNT === 0) {
                this.setSecondHandlerValue();

                this.inputs[handle].value = values[handle];
                this.resultElement.textContent = `${this.inputMin.value} - ${this.inputMax.value}${this.suffix}`;

                // показывать тултип
                const event = new Event('change');
                this.element.dispatchEvent(event);

                return;
            }

            this.setPlaceholders(handle);
            this.FIRST_UPDATE_COUNT -= 1;
        });

        // Listen to keydown events on the input field.
        this.inputs.forEach((input, handle) => {
            input.addEventListener('change', (evt) => {
                evt.preventDefault();
                this.slider.setHandle(handle, input.value);
                this.resultElement.textContent = `${this.inputMin.value} - ${this.inputMax.value}${this.suffix}`;
            });

            input.addEventListener('keypress', (evt) => {
                if (evt.keyCode === 13) {
                    evt.preventDefault();
                    this.slider.setHandle(handle, input.value);
                    this.resultElement.textContent = `${this.inputMin.value} - ${this.inputMax.value}${this.suffix}`;
                }
            });
        });
    }

    checkInitValue() {
        let { min, max } = this;

        const minValue = +this.inputMin.value;
        const maxValue = +this.inputMax.value;

        if (minValue || maxValue) {
            this.FIRST_UPDATE_COUNT = 0;
            min = minValue || this.inputMin.dataset.range;
            max = maxValue || this.inputMax.dataset.range;
        }

        return [min, max];
    }

    /**
     * Как только "дергаем" любое значение -- второе берётся по дефолту
     */
    setSecondHandlerValue() {
        if (this.isRangeInit) return;

        this.inputs.forEach((inputElement) => {
            if (inputElement.value) return;

            // eslint-disable-next-line no-param-reassign
            inputElement.value = inputElement.dataset.range;
        });

        this.isRangeInit = true;
    }

    /**
     * установка плейсхолдера при первичной инициализации слайдера
     */
    setPlaceholders(index) {
        this.inputs[index].value = '';
        this.inputs[index].placeholder = this.placeholderFormat.to(+this.inputs[index].dataset.range);
        // this.resultElement.textContent = `${this.min} - ${this.max}${this.suffix}`;
        this.resultElement.textContent = `${this.placeholderFormat.to(this.min)} - ${this.placeholderFormat.to(this.max)}${this.suffix}`;
    }

    static destroy(element, selector = '.filter-slider__range') {
        const stepsSlider = element.querySelector(selector);
        const resultElement = element.querySelector('.filter-dropdown__text');
        const inputMin = element.querySelector('.price-min');
        const inputMax = element.querySelector('.price-max');

        inputMin.value = '';
        inputMax.value = '';
        resultElement.textContent = '';

        stepsSlider.noUiSlider.destroy();
    }
}
